import React, { useRef, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  Wrapper,
  Title,
  CodeWrapper,
  ErrorMessage,
  ExpiryHint
} from './styled';
import CodeField from './components/CodeField';

const TOTP_STEP_SECONDS = 30;

const getSecondsUntilCodeRefresh = () => TOTP_STEP_SECONDS - (Math.floor(Date.now() / 1000) % TOTP_STEP_SECONDS);

const SecretCode = ({ onChange, submit, error = '' }) => {
  const intl = useIntl();
  const [codes, setCodes] = useState(['', '', '', '', '', '']);
  const [secondsUntilRefresh, setSecondsUntilRefresh] = useState(getSecondsUntilCodeRefresh());
  const refs = useRef([]);

  useEffect(() => {
    if (refs.current[0]) {
      refs.current[0].focus();
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setSecondsUntilRefresh(getSecondsUntilCodeRefresh()), 1000);
    return () => clearInterval(interval);
  }, []);

  const handleInputChange = (index) => (value) => {
    const newArr = [...codes];
    newArr[index] = value;
    setCodes(newArr);

    if (index < 5 && value) {
      refs.current[index + 1].focus();
    }

    if (onChange) onChange(newArr.join(''));
  };

  const handleBackspace = (index) => () => {
    if (index > 0) {
      refs.current[index - 1].focus();
    }
  };

  return (
    <Wrapper>
      <Title>{intl.formatMessage({ id: 'preferences.account.twoFactorAuthentication.secretCode.title' })}</Title>
      <CodeWrapper>
        {Array.from({ length: 6 }).map((_, i) => (
          <CodeField
            key={ i }
            ref={ (el) => (refs.current[i] = el) }
            value={ codes[i] }
            onChange={ handleInputChange(i) }
            onEnter={ submit }
            onBackspace={ handleBackspace(i) }
          />
        ))}
      </CodeWrapper>
      { error ? <ErrorMessage>{error}</ErrorMessage> : null}
      <ExpiryHint>
        {intl.formatMessage(
          { id: 'preferences.account.twoFactorAuthentication.secretCode.expiryHint' },
          { seconds: secondsUntilRefresh }
        )}
      </ExpiryHint>
    </Wrapper>
  );
};

export default SecretCode;
